const handleClickDeleteChecklistModalEquipService = {
  confirm: '¿Realmente desea eliminar la checklist completa de este sitio?',
  title: 'ELIMINAR CHECKLIST'
}

export default handleClickDeleteChecklistModalEquipService;
